<template>

    <vx-card :title="GPU.worker_name + ' - ' + ((GPU.type === 0) ? 'Nvidia' : 'AMD') + ((GPU.custom_name.length > 0) ? ' - ' + GPU.custom_name : '') + ' - ' + GPU.name + ' - ' + GPU.total_memory + ' MB'" :id="GPU.uuid" class="vs-con-loading__container">

        <template slot="actions">
            <router-link :to="'/gpu/' + GPU.uuid">
                <feather-icon icon="ExternalLinkIcon" class="mr-6"></feather-icon>
            </router-link>

            <vs-dropdown vs-trigger-click class="cursor-pointer mr-3">
                <small class="flex cursor-pointer">
                    <span>{{metricTimes[timeRange]}}</span>
                    <feather-icon icon='ChevronDownIcon' svgClasses='h-4 w-4' class='ml-1' />
                </small>
                <vs-dropdown-menu class="w-48">
                    <vs-dropdown-item @click="timeRange = 1">Last hour</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 6">Last 6 hours</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 12">Last 12 hours</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 24">Last 24 hours</vs-dropdown-item>
                    <vs-dropdown-item @click="timeRange = 167">Last 7 days</vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>

            <feather-icon icon="RefreshCwIcon" @click="loadData()"></feather-icon>

        </template>

        <vue-apex-charts v-if="chartOptions" type="line" height="350" :options="chartOptions" :series="chartData"/>

    </vx-card>

</template>
<script>

    import VueApexCharts from 'vue-apexcharts'

    export default {
        props: {
            GPU: {
                type: Object,
                required: true
            }
        },
        components: {
            VueApexCharts
        },
        data() {
            return {

                chartData: [],
                timeRange: 1,

                metricTimes: {
                    1: 'Last hour',
                    6: 'Last 6 hours',
                    12: 'Last 12 hours',
                    24: 'Last 24 hours',
                    167: 'Last 7 days'

                },

                chartOptions: {
                    colors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43'],
                    xaxis: {
                        type: 'datetime',
                        tickAmount: 6,
                        labels: {
                            datetimeUTC: false
                        }
                    },
                    yaxis: {
                        min: 0,
                        max: 100,
                        tickAmount: 5,
                        decimalsInFloat: 2,
                        labels: {
                            formatter: function(value) {
                                return value.toFixed(2) + '%'
                            }
                        }
                    },
                    tooltip: {
                        x: {
                            format: 'dd/MM/yyyy HH:mm:ss'
                        }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    stroke: {
                        curve: 'straight'
                    },
                    title: {
                        text: 'Utilization',
                        align: 'left'
                    }
                }

            }
        },
        methods: {
            loadData() {
                this.$vs.loading({
                    container: '#' + this.GPU.uuid,
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/gpu/' + this.GPU.uuid + '/metrics/' + this.timeRange + '/utilization')
                loadPromise.then(function(response) {
                    thisIns.chartData = JSON.parse(JSON.stringify(response.data))
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                })

                loadPromise.finally(function() {
                    thisIns.$vs.loading.close('#' + thisIns.GPU.uuid + ' > .con-vs-loading')
                })
            }
        },
        watch: {
            timeRange() {
                this.loadData()
            }
        },
        mounted() {
            this.loadData()
        }
    }

</script>
